<mat-sidenav-container>
  @if (!isFullscreen) {
    <mat-sidenav
      id="sidenav"
      [disableClose]="true"
      [fixedInViewport]="true"
      mode="side"
      opened="true"
    >
      <div class="mat-sidenav-inner flex-column-center">
        <div class="sidenav-header flex-column-center">
          <a [routerLink]="['/']" aria-label="Home" class="sidenav-logo" i18n-aria-label></a>
          <div data-cy="sidenav-list" class="sidenav-list flex-column-center">
            @for (navItem of menuItems; track navItem.path) {
              <a
                *coreHasRights="navItem.rights"
                #rla="routerLinkActive"
                [attr.aria-label]="navItem.title"
                [routerLinkActive]="['active']"
                [routerLink]="navItem.path"
                [queryParams]="navItem.useQueryParams ? periodService.value.queryParams : null"
                [attr.data-cy]="'sidenav-item-' + navItem.title.toLowerCase()"
                class="sidenav-item flex-column-center"
              >
                <mat-icon
                  class="sidenav-item__icon flex-column-center fill"
                  [svgIcon]="navItem.icon + '_fill'"
                ></mat-icon>
                <mat-icon
                  class="sidenav-item__icon flex-column-center outline"
                  [svgIcon]="navItem.icon + '_outline'"
                ></mat-icon>
                <span class="sidenav-item__text">{{ navItem.title }}</span>
              </a>
            }
          </div>
        </div>

        <div class="sidenav-footer flex-column-center">
          @if (version && !(configurationService.config | async)?.slim) {
            <a
              aria-label="Back to version 1"
              data-cy="sidenav-version-1-button"
              href="/web/"
              i18n-matTooltip
              matTooltip="Back to version 1"
              matTooltipPosition="after"
              class="sidenav-item"
            >
              <mat-icon class="sidenav-item__icon">settings_backup_restore</mat-icon>
            </a>
          }
          <button
            type="button"
            class="sidenav-item"
            [class.badge]="highlightService.unread$ | async"
            data-cy="sidenav-open-docs-button"
            i18n-matTooltip
            matTooltip="Help"
            matTooltipPosition="after"
            [matMenuTriggerFor]="menu"
          >
            <mat-icon class="sidenav-item__icon">help_outline</mat-icon>
            <span class="sidenav-item__sr-text" i18n>Help</span>
            @if (highlightService.unread$ | async; as unread) {
              <span class="sidenav-item__sr-text" i18n
                >, {unread, plural, =1 {1 unread news} other {{{ unread }} unread news}}</span
              >
            }
          </button>
          <app-profile-button></app-profile-button>
          <div class="version">{{ version }}</div>
        </div>
      </div>
    </mat-sidenav>
  }

  <mat-sidenav-content [style.margin-left]="isFullscreen ? 0 : '80px'">
    <router-outlet></router-outlet>
  </mat-sidenav-content>

  <mat-sidenav
    (opened)="helpDrawerOpened()"
    id="drawer"
    #drawer
    mode="over"
    position="end"
    role="dialog"
    aria-modal="true"
    aria-labelledby="help-drawer-title"
  >
    <app-help-drawer (closeDrawer)="drawer.close()"></app-help-drawer>
  </mat-sidenav>
</mat-sidenav-container>

<mat-menu #menu="matMenu" yPosition="above">
  <ng-template matMenuContent>
    <div class="actions-group">
      <a mat-menu-item href="/docs/" target="_blank">
        <mat-icon
          inline="true"
          class="mat-side-nav__footer__content__icon material-icons-outlined"
          color="accent"
          >menu_book</mat-icon
        >
        <span i18n>Open documentation</span>
      </a>
      <button mat-menu-item type="button" (click)="drawer.toggle()">
        <mat-icon
          inline="true"
          class="mat-side-nav__footer__content__icon material-icons-outlined"
          color="accent"
          >campaign</mat-icon
        >
        <div class="flex-row-horizontal-space-between-vertical-center">
          <span i18n>What's new</span>
          @if (highlightService.unread$ | async) {
            <mat-chip class="highlight-chip">{{ highlightService.unread$ | async }}</mat-chip>
          }
        </div>
      </button>
    </div>
  </ng-template>
</mat-menu>
